import React, { useEffect, useState } from "react";
import styles from "../RolesPermissonForm.module.scss";
import { Collapse } from "antd";
import {
  checkboxNames,
  FinanceSectionSublist,
  getActiveKeys,
} from "./constants";
import InputField from "../../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";
import { useFormContext } from "react-hook-form";

const FinanceSectionOptions = () => {
  const { Panel } = Collapse;
  const [disabledCheckbox, setDisabledCheckbox] = useState({
    [checkboxNames.TP_DATA_INPUT]: false,
    [checkboxNames.TP_MANAGER_REVIEW]: false,
    [checkboxNames.TP_ARCHIVE_VIEW]: false,
    [checkboxNames.TU_EDIT]: false,
  });
  const { setValue, getValues, watch } = useFormContext();

  const handleCheckboxChange = (name: string, val: boolean) => {
    switch (name) {
      case checkboxNames.TP_MANAGER_REVIEW: {
        setValue(checkboxNames.TP_DATA_INPUT, val);
        setDisabledCheckbox((prev) => ({
          ...prev,
          [checkboxNames.TP_DATA_INPUT]: val,
        }));
        break;
      }
      case checkboxNames.TP_ARCHIVE_VIEW: {
        setValue(checkboxNames.TP_MANAGER_REVIEW, val);
        setValue(checkboxNames.TP_DATA_INPUT, val);
        setDisabledCheckbox((prev) => ({
          ...prev,
          [checkboxNames.TP_DATA_INPUT]: val,
          [checkboxNames.TP_MANAGER_REVIEW]: val,
        }));
        break;
      }
      case checkboxNames.TP_ARCHIVE_EDIT: {
        setValue(checkboxNames.TP_ARCHIVE_VIEW, val);
        setValue(checkboxNames.TP_MANAGER_REVIEW, val);
        setValue(checkboxNames.TP_DATA_INPUT, val);
        setDisabledCheckbox((prev) => ({
          ...prev,
          [checkboxNames.TP_DATA_INPUT]: val,
          [checkboxNames.TP_MANAGER_REVIEW]: val,
          [checkboxNames.TP_ARCHIVE_VIEW]: val,
        }));
        break;
      }
      case checkboxNames.TU_REVIEW: {
        setValue(checkboxNames.TU_EDIT, val);
        setDisabledCheckbox((prev) => ({
          ...prev,
          [checkboxNames.TU_EDIT]: val,
        }));
        break;
      }
      case checkboxNames.LM_EDIT:
        setValue(checkboxNames.LM_VIEW, val);
        setDisabledCheckbox((prev) => ({
          ...prev,
          [checkboxNames.LM_VIEW]: val,
        }));
        break;
      case checkboxNames.IM_EDIT:
        setValue(checkboxNames.IM_VIEW, val);
        setDisabledCheckbox((prev) => ({
          ...prev,
          [checkboxNames.IM_VIEW]: val,
        }));
        break;
      case checkboxNames.PA_EDIT:
        setValue(checkboxNames.PA_VIEW, val);
        setDisabledCheckbox((prev) => ({
          ...prev,
          [checkboxNames.PA_VIEW]: val,
        }));
        break;
    }
    setValue(name, val);
  };

  useEffect(() => {
    if (getValues(checkboxNames.TU_REVIEW))
      setDisabledCheckbox((prev) => ({
        ...prev,
        [checkboxNames.TU_EDIT]: true,
      }));

    if (getValues(checkboxNames.TP_ARCHIVE_EDIT)) {
      setDisabledCheckbox((prev) => ({
        ...prev,
        [checkboxNames.TP_DATA_INPUT]: true,
        [checkboxNames.TP_MANAGER_REVIEW]: true,
        [checkboxNames.TP_ARCHIVE_VIEW]: true,
      }));
    } else if (getValues(checkboxNames.TP_ARCHIVE_VIEW)) {
      setDisabledCheckbox((prev) => ({
        ...prev,
        [checkboxNames.TP_DATA_INPUT]: true,
        [checkboxNames.TP_MANAGER_REVIEW]: true,
      }));
    } else if (getValues(checkboxNames.TP_MANAGER_REVIEW)) {
      setDisabledCheckbox((prev) => ({
        ...prev,
        [checkboxNames.TP_DATA_INPUT]: true,
      }));
    } 
    if (getValues(checkboxNames.IM_EDIT)) {
      setDisabledCheckbox((prev) => ({
        ...prev,
        [checkboxNames.IM_VIEW]: true,
      }));
    }
    if (getValues(checkboxNames.LM_EDIT)) {
      setDisabledCheckbox((prev) => ({
        ...prev,
        [checkboxNames.LM_VIEW]: true,
      }));
    } 
    if (getValues(checkboxNames.PA_EDIT)) {
      setDisabledCheckbox((prev) => ({
        ...prev,
        [checkboxNames.PA_VIEW]: true,
      }));
    }
  }, []);

  return (
    <Collapse
      ghost
      expandIconPosition={"right"}
      defaultActiveKey={getActiveKeys(getValues())}
      bordered={false}
    >
      {FinanceSectionSublist.map((item) => (
        <Panel
          key={item.key}
          header={item.label}
          className={styles.innerSection}
        >
          <div className={styles.checkboxContainer}>
            {item.options?.map((listItem) => (
              <InputField
                name={listItem.name}
                label={listItem.label}
                type={InputfieldTypes.CHECKBOX}
                disabled={
                  Object.keys(disabledCheckbox).includes(listItem.name)
                    ? disabledCheckbox[listItem.name]
                    : false
                }
                onChange={(val) => handleCheckboxChange(listItem.name, val)}
                value={watch(listItem.name)}
              />
            ))}
          </div>
        </Panel>
      ))}
    </Collapse>
  );
};

export default FinanceSectionOptions;
